"use strict";
/** @module models */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobTimeouts = exports.AgencyTranslation = exports.AgencyTranslations = exports.AgencyFeatures = exports.GroupStats = exports.AgencyClientStats = exports.LongAgency = exports.ParserHistory = exports.LongSCUAgency = exports.LongClientAgency = exports.ShortClientAgency = exports.AgencySCUUnit = exports.SCUUnit = exports.ClientUnit = exports.ShortAgency = exports.isDirty = exports.Agency = exports.UserAgency = exports.SearchAgency = exports.MinimalAgency = exports.AgencySettings = exports.Stream = exports.Station = exports.AgencyRegion = void 0;
var cerealParse_1 = require("../cerealParse");
var format_1 = require("../utils/functions/format");
var group_1 = require("./group");
var unit_1 = require("./unit");
var audioStream_1 = require("./audioStream");
var hospital_1 = require("./hospital");
var auth_1 = require("./auth");
/** AgencyRegion class. */
var AgencyRegion = /** @class */ (function () {
    /**
     * Create an agency region.
     * @param {string} agencyId - The agency id.
     * @param {string} city - The agency city.
     * @param {string} state - The agency state.
     * @param {GeoJsonObject} bufferedBoundary - Buffered boundary.
     */
    function AgencyRegion(agencyId, city, state, bufferedBoundary) {
        this.agencyId = agencyId;
        this.city = city;
        this.state = state;
        this.bufferedBoundary = bufferedBoundary;
    }
    /**
     * Parse agency region.
     * @param Object to parse.
     * @return Parse result of agency region.
     */
    AgencyRegion.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new AgencyRegion(cerealParse_1.ParseUtils.getString(o, 'agencyId'), format_1.toTitleCase(cerealParse_1.ParseUtils.getString(o, 'city')), cerealParse_1.ParseUtils.getString(o, 'state').toUpperCase(), o['bufferedBoundary']));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid AgencyRegion: " + e.message);
        }
    };
    return AgencyRegion;
}());
exports.AgencyRegion = AgencyRegion;
/** Station class. */
var Station = /** @class */ (function () {
    function Station(id, headquarters, location, name, address) {
        this.id = id;
        this.headquarters = headquarters;
        this.location = location;
        this.name = name;
        this.address = address;
    }
    Object.defineProperty(Station.prototype, "latitude", {
        get: function () {
            return this.location.coordinates[1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Station.prototype, "longitude", {
        get: function () {
            return this.location.coordinates[0];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Parse station.
     * @param o Object to parse.
     * @return Parse result of station.
     */
    Station.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new Station(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getBoolean(o, 'hq'), o['location'], cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'addr')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Station: " + e.message);
        }
    };
    /**
     * Compare stations.
     * @param s1 Station
     * @param s2 Station
     */
    Station.compare = function (s1, s2) {
        return s1.name.localeCompare(s2.name) || s1.id.localeCompare(s1.id);
    };
    return Station;
}());
exports.Station = Station;
/** Stream class. */
var Stream = /** @class */ (function () {
    /**
     * Stream constructor.
     * @WARN Currently does not assign anything.
     * @param id
     * @param name
     * @param url
     */
    function Stream(id, name, url) {
        this.id = id;
        this.name = name;
        this.url = url;
    }
    /**
     * Parse stream.
     * @param o Object to parse.
     * @return Parse result of stream.
     */
    Stream.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new Stream(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'url')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Stream: " + e.message);
        }
    };
    return Stream;
}());
exports.Stream = Stream;
/** Agency Setting class. */
var AgencySettings = /** @class */ (function () {
    function AgencySettings(userResponding, apparatusResponding, showHydrants, requirePasscode) {
        this.userResponding = userResponding;
        this.apparatusResponding = apparatusResponding;
        this.showHydrants = showHydrants;
        this.requirePasscode = requirePasscode;
    }
    /**
     * Check equality of another AgencySettings instance.
     * @param settingsObject
     * @result True if equal.
     */
    AgencySettings.prototype.equals = function (settingsObject) {
        return settingsObject.userResponding == this.userResponding &&
            settingsObject.apparatusResponding == this.apparatusResponding &&
            settingsObject.showHydrants == this.showHydrants &&
            settingsObject.requirePasscode == this.requirePasscode;
    };
    /**
     * Create copy of AgencySettings instance.
     * @return New, identical AgencySettings instance.
     */
    AgencySettings.prototype.getCopy = function () {
        return new AgencySettings(this.userResponding, this.apparatusResponding, this.showHydrants, this.requirePasscode);
    };
    /**
     * Parse agency settings.
     * @param o Object to parse.
     * @return Parse result of agency settings.
     */
    AgencySettings.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new AgencySettings(cerealParse_1.ParseUtils.getString(o, 'userResponding'), cerealParse_1.ParseUtils.getString(o, 'apparatusResponding'), cerealParse_1.ParseUtils.getBoolean(o, 'showHydrants'), cerealParse_1.ParseUtils.getBoolean(o, 'requirePasscode')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Agency Settings: " + e.message);
        }
    };
    return AgencySettings;
}());
exports.AgencySettings = AgencySettings;
/**
 * Minimal agency model.
 * [Spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Models/Agency.md#minimalagency-object)
 */
var MinimalAgency = /** @class */ (function () {
    function MinimalAgency(id, name) {
        this.id = id;
        this.name = name;
    }
    /**
     * Parse minimal agency.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    MinimalAgency.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new MinimalAgency(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid MinimalAgency: " + e.message);
        }
    };
    return MinimalAgency;
}());
exports.MinimalAgency = MinimalAgency;
// class Parsable {
//   static parse<T>(...args: any[]): ParseResult<T> {
//     try {
//       return ParseUtils.parseSuccess(new T(
//         ...args,
//       ));
//     } catch (e) {
//       return ParseUtils.parseFailure<T>(`Invalid parse: ${e.message}`);
//     }
//   }
// }
/**
 * Search agency model. Should implement MinimalAgency.
 * [Spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Models/Agency.md#searchagency-object)
 */
var SearchAgency = /** @class */ (function () {
    function SearchAgency(id, name, country, region, district, isMember, dispatchGroups) {
        this.id = id;
        this.name = name;
        this.country = country;
        this.region = region;
        this.district = district;
        this.isMember = isMember;
        this.dispatchGroups = dispatchGroups;
    }
    Object.defineProperty(SearchAgency.prototype, "hasGroups", {
        /**
         * Get if agency has dispatch groups.
         */
        get: function () {
            return (this.dispatchGroups || []).length >= 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SearchAgency.prototype, "memberOfAllGroups", {
        /**
         * Get if client requesting SearchAgency is member of all dispatch groups.
         */
        get: function () {
            if (this.isMember) {
                if (this.hasGroups) {
                    return (this.dispatchGroups || []).every(function (g) { return g.isMember; });
                }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Parse search agency.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    SearchAgency.parse = function (o) {
        try {
            if (o['dispatchGroups']) { // Check if dispatchGroups provided
                return cerealParse_1.ParseUtils.parseSuccess(new SearchAgency(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'country'), cerealParse_1.ParseUtils.getStringOrNull(o, 'region'), cerealParse_1.ParseUtils.getStringOrNull(o, 'district'), cerealParse_1.ParseUtils.getBoolean(o, 'member'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'dispatchGroups', group_1.SearchDispatchGroup.parse, 'ignore')));
            }
            return cerealParse_1.ParseUtils.parseSuccess(new SearchAgency(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'country'), cerealParse_1.ParseUtils.getString(o, 'state'), cerealParse_1.ParseUtils.getStringOrNull(o, 'region'), cerealParse_1.ParseUtils.getBoolean(o, 'member')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SearchAgency: " + e.message);
        }
    };
    return SearchAgency;
}());
exports.SearchAgency = SearchAgency;
/**
 * User agency model. Should implement MinimalAgency.
 * [Spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Models/Agency.md#useragency-object)
 */
var UserAgency = /** @class */ (function () {
    function UserAgency(id, name, isManager, dispatchGroups) {
        this.id = id;
        this.name = name;
        this.isManager = isManager;
        this.dispatchGroups = dispatchGroups;
    }
    Object.defineProperty(UserAgency.prototype, "hasGroups", {
        /**
         * Get if agency includes dispatch groups that the requesting
         * user is assigned to.
         */
        get: function () {
            return (this.dispatchGroups || []).length >= 1;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Parse user agency.
     * @TODO Clean up. There's kludges in this function.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    UserAgency.parse = function (o) {
        try {
            if (o['dispatchGroups']) {
                return cerealParse_1.ParseUtils.parseSuccess(new UserAgency(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getBoolean(o, 'manager'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'dispatchGroups', group_1.MinimalDispatchGroup.parse, 'ignore')));
            }
            else {
                return cerealParse_1.ParseUtils.parseSuccess(new UserAgency(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getBoolean(o, 'manager')));
            }
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid UserAgency: " + e.message);
        }
    };
    return UserAgency;
}());
exports.UserAgency = UserAgency;
//
// /**
//  * Management auth agency model.
//  * (Originally coppyied from auth.ts)
//  * [Spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Models/Agency.md#managementauthagency-object)
//  */
// export class ManagementAuthAgency implements MinimalAgency {
//   private constructor(
//     public id: string,
//     public name: string,
//     public agencyKey: string,
//     public exposeExternalId: boolean,
//     public stationBoard: StationBoardFeature,
//   ) { }
//
//   static notifyReplace: (agency: AuthAgency) => void = () => null;
//
//   /**
//    * Parse object potentially representing a AuthAgency.
//    * @param o
//    * @return Parse result
//    */
//   static parse(o: any): ParseResult<AuthAgency> {
//     try {
//       return ParseUtils.parseSuccess(new AuthAgency(
//         ParseUtils.getString(o, 'id'),
//         ParseUtils.getString(o, 'name'),
//         ParseUtils.getString(o, 'agencyKey'),
//         ParseUtils.getBoolean(o, 'exposeExternalId'),
//         ParseUtils.getSubobject(o, 'stationBoard', StationBoardFeature.parse),
//       ));
//     } catch (e) {
//       return ParseUtils.parseFailure<AuthAgency>(`Invalid Agency: ${e.message}`);
//     }
//   }
// }
/**
 * Full agency model.
 * [Spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Models/Agency.md#fullagency-object)
 */
var Agency = /** @class */ (function () {
    function Agency(id, bufferedBoundary, settings, stations, name) {
        this.id = id;
        this.bufferedBoundary = bufferedBoundary;
        this.settings = settings;
        this.stations = stations;
        this.name = name;
    }
    /**
     * Parse agency.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    Agency.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new Agency(cerealParse_1.ParseUtils.getString(o, 'id'), o['bufferedBoundary'], cerealParse_1.ParseUtils.getSubobject(o, 'settings', AgencySettings.parse), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'stations', Station.parse, 'warn'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Agency: " + e.message);
        }
    };
    return Agency;
}());
exports.Agency = Agency;
/**
 * Checks if body has any values
 * @param body EditAgencyBody
 */
function isDirty(body) {
    return body.agencyKey != null ||
        body.boundary != null ||
        body.country != null ||
        body.county != null ||
        body.latitude != null ||
        body.longitude != null ||
        body.name != null ||
        body.state != null ||
        body.timezone != null ||
        body.town != null ||
        body.usfaId != null ||
        body.stripeCustomerId != null ||
        body.oldJobTimeout != null ||
        body.timedOutJobTimeout != null;
}
exports.isDirty = isDirty;
/** ShortAgency class. */
var ShortAgency = /** @class */ (function (_super) {
    __extends(ShortAgency, _super);
    function ShortAgency(id, name, agencyKey) {
        var _this = _super.call(this, id, name) || this;
        _this.id = id;
        _this.name = name;
        _this.agencyKey = agencyKey;
        return _this;
    }
    /**
     * Parse short agency.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    ShortAgency.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ShortAgency(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'agencyKey')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ShortAgency: " + e.message);
        }
    };
    return ShortAgency;
}(MinimalAgency));
exports.ShortAgency = ShortAgency;
/** ClientUnit class. */
var ClientUnit = /** @class */ (function () {
    function ClientUnit(id, name, canRespond) {
        this.id = id;
        this.name = name;
        this.canRespond = canRespond;
    }
    /**
     * Parse client unit.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    ClientUnit.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ClientUnit(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getBoolean(o, 'canRespond')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ClientUnit: " + e.message);
        }
    };
    return ClientUnit;
}());
exports.ClientUnit = ClientUnit;
/** SCUUnit class. */
var SCUUnit = /** @class */ (function () {
    function SCUUnit(id, name, silent) {
        this.id = id;
        this.name = name;
        this.silent = silent;
    }
    /**
     * Parse scu unit.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    SCUUnit.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUUnit(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getBoolean(o, 'silent')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUUnit: " + e.message);
        }
    };
    return SCUUnit;
}());
exports.SCUUnit = SCUUnit;
/** AgencySCUUnit class. */
var AgencySCUUnit = /** @class */ (function () {
    function AgencySCUUnit(id, name) {
        this.id = id;
        this.name = name;
    }
    /**
     * Parse scu unit.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    AgencySCUUnit.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new AgencySCUUnit(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid AgencySCUUnit: " + e.message);
        }
    };
    return AgencySCUUnit;
}());
exports.AgencySCUUnit = AgencySCUUnit;
/** ShortClientAgency class. */
var ShortClientAgency = /** @class */ (function () {
    function ShortClientAgency(id, name, agencyKey, isManager) {
        this.id = id;
        this.name = name;
        this.agencyKey = agencyKey;
        this.isManager = isManager;
    }
    /**
     * shortId
     * @return shortId
     */
    ShortClientAgency.prototype.shortId = function () {
        var parts = this.agencyKey.split('.');
        return parts[parts.length - 1].toUpperCase();
    };
    /**
     * Compare agencies.
     * @param ca1 ShortClientAgency
     * @param ca2 ShortClientAgency.
     * @return Parse result of agency.
     */
    ShortClientAgency.compare = function (ca1, ca2) {
        return +ca2.isManager - +ca1.isManager || ca1.name.localeCompare(ca2.name);
    };
    /**
     * Parse short client agency.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    ShortClientAgency.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ShortClientAgency(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'agencyKey'), cerealParse_1.ParseUtils.getBoolean(o, 'isManager')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ShortClientAgency: " + e.message);
        }
    };
    return ShortClientAgency;
}());
exports.ShortClientAgency = ShortClientAgency;
/** LongClientAgency class. */
var LongClientAgency = /** @class */ (function () {
    function LongClientAgency(id, name, agencyKey, isManager, isDispatcher, isHidden, units) {
        this.id = id;
        this.name = name;
        this.agencyKey = agencyKey;
        this.isManager = isManager;
        this.isDispatcher = isDispatcher;
        this.isHidden = isHidden;
        this.units = units;
    }
    /**
     * shortId
     * @return shortId
     */
    LongClientAgency.prototype.shortId = function () {
        var parts = this.agencyKey.split('.');
        return parts[parts.length - 1].toUpperCase();
    };
    /**
     * hasUnit
     * @param unitId string
     * @return boolean
     */
    LongClientAgency.prototype.hasUnit = function (unitId) {
        return this.units.filter(function (u) { return unitId == u.id; }).length > 0;
    };
    /**
     * Compare agencies.
     * @param ca1 LongClientAgency.
     * @param ca2 LongClientAgency.
     * @return Parse result of agency.
     */
    LongClientAgency.compare = function (ca1, ca2) {
        return +ca2.isManager - +ca1.isManager || ca1.name.localeCompare(ca2.name);
    };
    /**
     * Parse long client agency.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    LongClientAgency.parse = function (o) {
        var shortPart = ShortClientAgency.parse(o);
        if (shortPart.success == false) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid LongClientAgency: " + shortPart.justification);
        }
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new LongClientAgency(shortPart.value.id, shortPart.value.name, shortPart.value.agencyKey, shortPart.value.isManager, cerealParse_1.ParseUtils.getBoolean(o, 'isDispatcher'), cerealParse_1.ParseUtils.getBoolean(o, 'isHidden'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'units', ClientUnit.parse, 'warn')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid LongClientAgency: " + e.message);
        }
    };
    return LongClientAgency;
}());
exports.LongClientAgency = LongClientAgency;
/** LongSCUAgency class. */
var LongSCUAgency = /** @class */ (function () {
    function LongSCUAgency(id, name, agencyKey, canManage, units) {
        this.id = id;
        this.name = name;
        this.agencyKey = agencyKey;
        this.canManage = canManage;
        this.units = units;
    }
    /**
     * shortId
     * @return shortId
     */
    LongSCUAgency.prototype.shortId = function () {
        var parts = this.agencyKey.split('.');
        return parts[parts.length - 1].toUpperCase();
    };
    /**
     * hasUnit
     * @param unitId string
     * @return boolean
     */
    LongSCUAgency.prototype.hasUnit = function (unitId) {
        return this.units.filter(function (u) { return unitId == u.id; }).length > 0;
    };
    /**
     * Compare agencies.
     * @param ca1 LongSCUAgency.
     * @param ca2 LongSCUAgency.
     * @return Parse result of agency.
     */
    LongSCUAgency.compare = function (ca1, ca2) {
        return +ca2.canManage - +ca1.canManage || ca1.name.localeCompare(ca2.name);
    };
    /**
     * Parse long scu agency.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    LongSCUAgency.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new LongSCUAgency(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'agencyKey'), cerealParse_1.ParseUtils.getBoolean(o, 'canManage'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'units', SCUUnit.parse, 'warn')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid LongSCUAgency: " + e.message);
        }
    };
    return LongSCUAgency;
}());
exports.LongSCUAgency = LongSCUAgency;
var ParserHistory = /** @class */ (function () {
    function ParserHistory(id, latestJobId) {
        this.id = id;
        this.latestJobId = latestJobId;
    }
    /**
     * Parse long agency.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    ParserHistory.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ParserHistory(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'latestJobId')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ParserHistory: " + e.message);
        }
    };
    /**
     * Compare agencies.
     * @param h1 ParserHistory.
     * @param h2 ParserHistory.
     * @return Parse result of agency.
     */
    ParserHistory.compare = function (h1, h2) {
        return h1.latestJobId > h2.latestJobId ? 1 : -1;
    };
    return ParserHistory;
}());
exports.ParserHistory = ParserHistory;
/** LongAgency class. */
var LongAgency = /** @class */ (function () {
    function LongAgency(id, name, agencyKey, country, state, town, county, usfaId, signupId, boundary, latitude, longitude, showHydrants, timezone, clientStats, groupStats, scuCount, units, stations, streams, stripeCustomerId, parsers, jobTimeouts, showOnSignup) {
        this.id = id;
        this.name = name;
        this.agencyKey = agencyKey;
        this.country = country;
        this.state = state;
        this.town = town;
        this.county = county;
        this.usfaId = usfaId;
        this.signupId = signupId;
        this.boundary = boundary;
        this.latitude = latitude;
        this.longitude = longitude;
        this.showHydrants = showHydrants;
        this.timezone = timezone;
        this.clientStats = clientStats;
        this.groupStats = groupStats;
        this.scuCount = scuCount;
        this.units = units;
        this.stations = stations;
        this.streams = streams;
        this.stripeCustomerId = stripeCustomerId;
        this.parsers = parsers;
        this.jobTimeouts = jobTimeouts;
        this.showOnSignup = showOnSignup;
    }
    /**
     * Parse long agency.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    LongAgency.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new LongAgency(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'agencyKey'), cerealParse_1.ParseUtils.getString(o, 'country'), cerealParse_1.ParseUtils.getString(o, 'state'), cerealParse_1.ParseUtils.getStringOrNull(o, 'town'), cerealParse_1.ParseUtils.getStringOrNull(o, 'county'), cerealParse_1.ParseUtils.getStringOrNull(o, 'usfaId'), cerealParse_1.ParseUtils.getStringOrNull(o, 'signupId'), o['boundary'], cerealParse_1.ParseUtils.getNumber(o, 'latitude'), cerealParse_1.ParseUtils.getNumber(o, 'longitude'), cerealParse_1.ParseUtils.getBoolean(o, 'showHydrants'), cerealParse_1.ParseUtils.getString(o, 'timezone'), cerealParse_1.ParseUtils.getSubobject(o, 'clientStats', AgencyClientStats.parse), cerealParse_1.ParseUtils.getSubobject(o, 'groupStats', GroupStats.parse), cerealParse_1.ParseUtils.getNumber(o, 'scuCount'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'units', unit_1.LongUnit.parse, 'warn').sort(unit_1.LongUnit.compare), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'stations', Station.parse, 'warn').sort(Station.compare), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'streams', audioStream_1.AudioStream.parse, 'warn').sort(audioStream_1.AudioStream.compare), cerealParse_1.ParseUtils.getStringOrNull(o, 'stripeCustomerId'), (cerealParse_1.ParseUtils.getArrayOfSubobjectsOrNull(o, 'parsers', ParserHistory.parse, 'warn') || []).sort(ParserHistory.compare), cerealParse_1.ParseUtils.getSubobject(o, "jobTimeouts", JobTimeouts.parse), cerealParse_1.ParseUtils.getBoolean(o, "showOnSignup")));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid LongAgency: " + e.message);
        }
    };
    return LongAgency;
}());
exports.LongAgency = LongAgency;
/** AgencyClientStats class. */
var AgencyClientStats = /** @class */ (function () {
    function AgencyClientStats(userCount, truckCount) {
        this.userCount = userCount;
        this.truckCount = truckCount;
    }
    /**
     * Parse agency client stats.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    AgencyClientStats.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new AgencyClientStats(cerealParse_1.ParseUtils.getNumber(o, 'userCount'), cerealParse_1.ParseUtils.getNumber(o, 'truckCount')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid AgencyClientStats: " + e.message);
        }
    };
    Object.defineProperty(AgencyClientStats.prototype, "total", {
        get: function () {
            return this.userCount + this.truckCount;
        },
        enumerable: false,
        configurable: true
    });
    return AgencyClientStats;
}());
exports.AgencyClientStats = AgencyClientStats;
/** GroupStats class. */
var GroupStats = /** @class */ (function () {
    function GroupStats(dispatchCount, messagingCount) {
        this.dispatchCount = dispatchCount;
        this.messagingCount = messagingCount;
    }
    /**
     * Parse group stats.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    GroupStats.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new GroupStats(cerealParse_1.ParseUtils.getNumber(o, 'dispatchCount'), cerealParse_1.ParseUtils.getNumber(o, 'messagingCount')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid GroupStats: " + e.message);
        }
    };
    Object.defineProperty(GroupStats.prototype, "total", {
        get: function () {
            return this.dispatchCount + this.messagingCount;
        },
        enumerable: false,
        configurable: true
    });
    return GroupStats;
}());
exports.GroupStats = GroupStats;
/** AgencyFeatures class. */
var AgencyFeatures = /** @class */ (function () {
    function AgencyFeatures(haEnabled, hospitals, stationBoardFeatureStatus) {
        this.haEnabled = haEnabled;
        this.hospitals = hospitals;
        this.stationBoardFeatureStatus = stationBoardFeatureStatus;
    }
    /**
     * Parse agency features.
     * @param o Object to parse.
     * @return Parse result of agency.
     */
    AgencyFeatures.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new AgencyFeatures(cerealParse_1.ParseUtils.getBoolean(o, 'haEnabled'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'hospitals', hospital_1.MinimalHospital.parse, 'warn'), cerealParse_1.ParseUtils.getSubobject(o, 'stationBoard', auth_1.StationBoardFeature.parse).toFeatureStatus()));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid AgencyFeatures: " + e.message);
        }
    };
    /**
     * Check if features status is equal
     * @param fs1 FeatureStatus
     * @param fs2 FeatureStatus
     */
    AgencyFeatures.featureStatusIsEqual = function (fs1, fs2) {
        if (fs1.type == 'enabled' && fs2.type == 'enabled') {
            return (fs1.expiration && fs1.expiration.getTime()) == (fs2.expiration && fs2.expiration.getTime());
        }
        else {
            return fs1.type == fs2.type;
        }
    };
    return AgencyFeatures;
}());
exports.AgencyFeatures = AgencyFeatures;
var AgencyTranslations = /** @class */ (function () {
    function AgencyTranslations(assignments, locations, descriptions) {
        this.assignments = assignments;
        this.locations = locations;
        this.descriptions = descriptions;
    }
    AgencyTranslations.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new AgencyTranslations(cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'assignments', AgencyTranslation.parse, 'throw'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'locations', AgencyTranslation.parse, 'throw'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'descriptions', AgencyTranslation.parse, 'throw')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid AgencyTranslations Model: " + e.message);
        }
    };
    return AgencyTranslations;
}());
exports.AgencyTranslations = AgencyTranslations;
var AgencyTranslation = /** @class */ (function () {
    function AgencyTranslation(id, pattern, replaceWith) {
        this.id = id;
        this.pattern = pattern;
        this.replaceWith = replaceWith;
    }
    AgencyTranslation.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new AgencyTranslation(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'pattern'), cerealParse_1.ParseUtils.getString(o, 'replaceWith')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid AgencyTranslation Model: " + e.message);
        }
    };
    return AgencyTranslation;
}());
exports.AgencyTranslation = AgencyTranslation;
var JobTimeouts = /** @class */ (function () {
    function JobTimeouts(old, timedOut) {
        this.old = old;
        this.timedOut = timedOut;
    }
    JobTimeouts.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new JobTimeouts(cerealParse_1.ParseUtils.getNumber(o, 'old'), cerealParse_1.ParseUtils.getNumber(o, 'timedOut')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid JobTimeouts: " + e.message);
        }
    };
    return JobTimeouts;
}());
exports.JobTimeouts = JobTimeouts;
//# sourceMappingURL=agency.js.map